import React, { Component } from 'react';
import { Form, Button, Select, Input, message } from 'antd';
import { ContactWrapper } from './style';
import { CONTACT_ACTIONS } from '../../config/constants';
import { getCookie } from '../../common/utils';
import { postContact } from '../../common/fetch';
import CONTACT_TYPE from './ContactType.json';

const { Option } = Select;
const { TextArea } = Input;

class UpgradeContact extends Component {
	state = {
		loading: false
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.setState(
			{
				loading: true
			},
			async () => {
				const { onOk, onError, type } = this.props;
				const { getFieldValue } = this.props.form;
				const vaultType =
					type === 0
						? 'Lite Type'
						: type === 1
						? 'Business Type'
						: 'Enterprise Type';
				const description =
					'Vault Type : ' + vaultType + '\n\n' + getFieldValue('message');
				const data = {
					email: getCookie('email'),
					category: getFieldValue('action'),
					subject: getFieldValue('action'),
					description
				};
				try {
					const res = await postContact(data);
					message.success(res.message);
					return onOk('Success');
				} catch (error) {
					return onError('Fail to message');
				}
			}
		);
	};

	render() {
		const { defaultType, onCancel, form } = this.props;
		const { loading } = this.state;
		const { getFieldDecorator, getFieldValue } = form;
		const key = getFieldValue('action') || defaultType;
		const OptionList = CONTACT_ACTIONS.map((key) => (
			<Option value={key} key={key}>
				{key}
			</Option>
		));
		const { description, warning } = CONTACT_TYPE[key];
		return (
			<Form onSubmit={this.handleSubmit}>
				<ContactWrapper>
					<p className="description">{description}</p>
					<p className="warning">{warning}</p>
					<div className="contact-type">
						<div> Action</div>
						{getFieldDecorator('action', {
							initialValue: defaultType
						})(<Select style={{ width: 170 }}>{OptionList}</Select>)}
					</div>
					<div>
						<div> Message</div>
						{getFieldDecorator('message')(
							<TextArea placeholder="Message"   />
						)}
					</div>
					<div className="btn-area">
						<Button key="back" onClick={onCancel} disabled={loading}>
							Return
						</Button>

						<Button
							key="submit"
							type="primary"
							onClick={this.handleSubmit}
							disabled={loading}
						>
							Submit
						</Button>
					</div>
				</ContactWrapper>
			</Form>
		);
	}
}

export default Form.create({
	name: 'UpgradeContact'
})(UpgradeContact);
